const REFERRAL_KEY = 'bookcloud_referral_code';
const REDIRECT_KEY = 'bookcloud_login_redirect';

export function captureReferral() {
  const url = new URL(window.location.href);

  const referralCode = url.searchParams.get('ref');
  const redirect = url.searchParams.get('redirect');

  // Save referral code
  if (referralCode) {
    sessionStorage.setItem(
      REFERRAL_KEY,
      referralCode
    );
  }

  // Save original destination
  if (redirect) {
    const decodedRedirect = decodeURIComponent(redirect);

    // Only allow internal routes
    if (
      decodedRedirect.startsWith('/') &&
      !decodedRedirect.startsWith('//') &&
      decodedRedirect !== '/login' &&
      decodedRedirect !== '/signup'
    ) {
      sessionStorage.setItem(
        REDIRECT_KEY,
        decodedRedirect
      );
    }
  }
}

export function getReferralCode() {
  return sessionStorage.getItem(REFERRAL_KEY);
}

export function getReferralRedirect() {
  return sessionStorage.getItem(REDIRECT_KEY);
}

export function clearReferralData() {
  sessionStorage.removeItem(REFERRAL_KEY);
  sessionStorage.removeItem(REDIRECT_KEY);
}